<template lang="pug">
Label(
    :tipo='definirTipo(tipo, elegivel)',
    :estilo='definirEstilo(elegivel)',
    :texto='definirRenovabio(elegivel)'
)
</template>

<script>
import Label from '@/modules/laudos/components/Label.vue';
import LabelTipo from '@/modules/laudos/constants/LabelTipo';
import LaudoUtils from '@/modules/laudos/utils/LaudoUtils';

export default {
    name: 'LabelLaudoRenovabio',

    components: {
        Label
    },

    props: {
        tipo: {
            type: String,
            required: true
        },
        elegivel: {
            type: Boolean,
            require: true
        }
    },

    methods: {
        definirTipo(tipo, elegivel) {
            if (elegivel == null) {
                return LabelTipo.TEXTO;
            }

            return tipo;
        },

        definirEstilo(elegivel) {
            return LaudoUtils.definirEstilo(this.definirCodigo(elegivel));
        },

        definirRenovabio(elegivel) {
            return LaudoUtils.definirRenovabio(this.definirCodigo(elegivel));
        },

        definirCodigo(elegivel) {
            if (elegivel == null) {
                return null;
            }

            return elegivel ? 'ELEGIVEL' : 'NAO_ELEGIVEL';
        }
    }
};
</script>

<style lang="scss" scoped></style>
